<template>
    <div class="container pt-2">
        <PageTitle main="Cadastro de Novo Cliente" sub="Preencha o formulário abaixo para se cadastrar!" />
        <b-form>
            <input id="cliente-id" type="hidden" v-model="cliente.id" />
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Nome:" label-for="cliente-nome">
                        <b-form-input id="cliente-nome" type="text"
                            v-model="cliente.nome"
                            placeholder="Informe o Nome do cliente."
                            :class="{ 'inputError': $v.cliente.nome.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.nome.$touch"/>
                        <span class="error" v-if="!$v.cliente.nome.required && $v.cliente.nome.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.nome.minLength && $v.cliente.nome.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <b-form-group label="Telefone:" label-for="cliente-telefone">
                        <b-form-input id="cliente-telefone" type="tel"
                            v-model="cliente.telefone" 
                            placeholder="Informe o telefone do cliente."
                            v-mask="['(##)####-####', '(##)#####-####']"
                            :class="{ 'inputError': $v.cliente.telefone.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.telefone.$touch"
                            />
                        <span class="error" v-if="!$v.cliente.telefone.required && $v.cliente.telefone.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.telefone.minLength && $v.cliente.telefone.$error">Digite o telefone completo com DDD!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="E-mail:" label-for="cliente-email">
                        <b-form-input id="cliente-email" type="email"
                            v-model="cliente.email" 
                            placeholder="Informe o E-mail do cliente."
                            :class="{ 'inputError': $v.cliente.email.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.email.$touch"
                            />
                        <span class="error" v-if="!$v.cliente.email.required && $v.cliente.email.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.email.email && $v.cliente.email.$error">Digite um email válido!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="CEP:" label-for="cliente-cep">
                        <b-form-input id="cliente-cep" type="text"
                            v-model="cliente.cep" 
                            placeholder="CEP"
                            v-mask="'#####-###'"
                            @keydown.tab="searchCep"
                            :class="{ 'inputError': $v.cliente.cep.$error }"
                            class="textInput"
                            />
                        <span class="error" v-if="!$v.cliente.cep.required && $v.cliente.cep.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.cep.minLength && $v.cliente.cep.$error">Digite um CEP completo!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <b-form-group label="Cidade:" label-for="cliente-cidade">
                        <b-form-input id="cliente-cidade" type="text"
                            v-model="cliente.cidade" 
                            placeholder="Informe o Cidade do cliente."
                            :class="{ 'inputError': $v.cliente.cidade.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.cidade.$touch"
                            />
                        <span class="error" v-if="!$v.cliente.cidade.required && $v.cliente.cidade.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="UF:" label-for="cliente-UF">
                        <b-form-select id="cliente-UF" :options="ufs" v-model="cliente.uf"
                        :class="{ 'inputError': $v.cliente.uf.$error }"
                        class="textInput"
                        @keydown.tab="$v.cliente.uf.$touch"
                        />
                        <span class="error" v-if="!$v.cliente.uf.required && $v.cliente.uf.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Logradouro:" label-for="cliente-logradouro">
                        <b-form-input id="cliente-logradouro" type="text"
                            v-model="cliente.logradouro" 
                            placeholder="Informe o logradouro do cliente."
                            :class="{ 'inputError': $v.cliente.logradouro.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.logradouro.$touch"
                            />
                        <span class="error" v-if="!$v.cliente.logradouro.required && $v.cliente.logradouro.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.logradouro.minLength && $v.cliente.logradouro.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-1">
                    <b-form-group label="Número:" label-for="cliente-numero">
                        <b-form-input id="cliente-numero" type="text"
                            v-model="cliente.numero"
                            placeholder="Nº"
                            :class="{ 'inputError': $v.cliente.numero.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.numero.$touch"
                            />
                        <span class="error" v-if="!$v.cliente.numero.required && $v.cliente.numero.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Complemento:" label-for="cliente-complemento">
                        <b-form-input id="cliente-complemento" type="text"
                            v-model="cliente.complemento"
                            class="textInput"
                            />
                    </b-form-group>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Senha:" label-for="cliente-senha">
                        <b-form-input id="cliente-senha" type="password"
                            v-model="cliente.senha"
                            placeholder="Digite a nova senha."
                            :class="{ 'inputError': $v.cliente.senha.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.senha.$touch"/>
                        <span class="error" v-if="!$v.cliente.senha.required && $v.cliente.senha.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.cliente.senha.minLength && $v.cliente.senha.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Confirmar Senha:" label-for="cliente-confirma">
                        <b-form-input id="cliente-confirma" type="password"
                            v-model="cliente.confirma"
                            placeholder="Confirme a nova senha."
                            :class="{ 'inputError': $v.cliente.confirma.$error }"
                            class="textInput"
                            @keydown.tab="$v.cliente.confirma.$touch"/>
                        <span class="error" v-if="!$v.cliente.confirma.sameAsclienteworda && $v.cliente.confirma.$error">Senha precisa ser igual a nova senha!</span>
                    </b-form-group>
                </div>
            </div>

            <b-button variant="outline-success" class="botaoInput" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
    </div>
</template>

<script>

import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mask } from 'vue-the-mask'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'clientes',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            ufs: [
                { value: 'AC', text: 'Acre' },
                { value: 'AL', text: 'Alagoas' },
                { value: 'AP', text: 'Amapa' },
                { value: 'AM', text: 'Amazonas' },
                { value: 'BA', text: 'Bahia' },
                { value: 'CE', text: 'Ceará' },
                { value: 'DF', text: 'Distrito Federal' },
                { value: 'ES', text: 'Espirito Santo' },
                { value: 'GO', text: 'Goiás' },
                { value: 'MA', text: 'Maranhão' },
                { value: 'MT', text: 'Mato Grosso' },
                { value: 'MS', text: 'Mato Grosso do Sul' },
                { value: 'MG', text: 'Minas Gerais' },
                { value: 'PA', text: 'Para' },
                { value: 'PB', text: 'Paraíba' },
                { value: 'PR', text: 'Paraná' },
                { value: 'PE', text: 'Pernambuco' },
                { value: 'PI', text: 'Piauí' },
                { value: 'RJ', text: 'Rio de Janeiro' },
                { value: 'RN', text: 'Rio Grande do Norte' },
                { value: 'RS', text: 'Rio Grande do Sul' },
                { value: 'RO', text: 'Rondônia' },
                { value: 'RR', text: 'Roraima' },
                { value: 'SC', text: 'Santa Catarina' },
                { value: 'SP', text: 'São Paulo' },
                { value: 'SE', text: 'Sergipe' },
                { value: 'TO', text: 'Tocantins' }
            ],
            cliente: {},
            clientes: [],
            fields: [
                { key: 'nome', label: 'Nome', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'telefone', label: 'Telefone', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'email', label: 'E-mail', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
        }
    },
    validations: {
        cliente: {
            nome: {
                required,
                minLength: minLength(4)
            },
            telefone: {
                required,
                minLength: minLength(10)
            },
            email: {
                required,
                email
            },
            cep: {
                required,
                minLength: minLength(8)
            },
            cidade: {
                required
            },
            uf: {
                required
            },
            logradouro: {
                required,
                minLength: minLength(4)
            },
            numero: {
                required
            },
            senha: {
                required,
                minLength: minLength(4)
            },
            confirma: {
                sameAsPassword: sameAs('senha')
            }
        }
    },
    methods: {
        searchCep () {
            this.$v.cliente.cep.$touch()
			if(this.cliente.cep.length == 9) {
				axios.get(`https://viacep.com.br/ws/${ this.cliente.cep }/json/`)
                .then( res => {
                    this.cliente.cidade = res.data.localidade
                    this.cliente.logradouro = res.data.logradouro
                    this.cliente.uf = res.data.uf
                    document.getElementById("cliente-logradouro").value = res.data.logradouro
                    document.getElementById("cliente-UF").value = res.data.uf
                    document.getElementById("cliente-cidade").value = res.data.localidade
                    document.getElementById("cliente-numero").focus()
                })
				.catch( error => console.log(error) )
			} else {
                document.getElementById("cliente-logradouro").value = ''
                document.getElementById("cliente-UF").value = ''
                document.getElementById("cliente-cidade").value = ''
            }
		},
        reset() {
            this.cliente = {}
            this.cliente.cidade = ''
            this.cliente.logradouro = ''
            this.cliente.uf = ''
            document.getElementById("cliente-logradouro").value = ''
            document.getElementById("cliente-UF").value = ''
            document.getElementById("cliente-cidade").value = ''
            this.$v.cliente.$reset()
        },
        save() {
            this.$v.cliente.$touch()
            if(!this.$v.cliente.$error){
                this.cliente.ativo = '1'
                axios['post'](`${baseApiUrl}/backend/clientes.php`, this.cliente)
                    .then(() => {
                        // const tipo = `?tipo=novoCliente`
                        // const destinoEmail = `&destinoEmail=${this.email}`
                        // const destinoNome = `&destinoNome=${this.nome}`
                        // axios.get(`${baseApiUrl}/backend/mailCliente.php${tipo}${destinoEmail}${destinoNome}`).then({})

                        this.$toasted.global.defaultSuccess({ message : 'Cliente inserido com sucesso!' })
                        this.reset()
                        this.$router.push({ path: '/login' })
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        loadCliente(cliente) {
            this.cliente = { ...cliente }
        }
    },
    mounted() {
    }
}
</script>

<style>
    
</style>